"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var item_1 = __importDefault(require("./item"));
var types_1 = require("../data/types");
var names_1 = require("../data/names");
var Armor = /** @class */ (function (_super) {
    __extends(Armor, _super);
    function Armor(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.type, type = _c === void 0 ? types_1.Unknown : _c, _d = _b.slot, slot = _d === void 0 ? types_1.Unknown : _d, craefterId = _b.craefterId, name = _b.name, level = _b.level, rarity = _b.rarity, _e = _b.def, def = _e === void 0 ? 0 : _e, _f = _b.mdef, mdef = _f === void 0 ? 0 : _f, material = _b.material, resources = _b.resources, delay = _b.delay;
        var _this = _super.call(this, {
            category: types_1.ItemCategories.Armor,
            name: name,
            craefterId: craefterId,
            slot: slot,
            level: level,
            type: type,
            rarity: rarity,
            material: material,
            resources: resources,
            delay: delay
        }) || this;
        _this._def = 0;
        _this._mdef = 0;
        _this._def = def;
        _this._mdef = mdef;
        return _this;
    }
    Armor.prototype.def = function () {
        return this._def * this.level;
    };
    Armor.prototype.mdef = function () {
        return this._mdef * this.level;
    };
    Armor.prototype.evaluateItemName = function () {
        var prefixes = [];
        if (this.rarity !== types_1.Rarities.Common) {
            prefixes.push(names_1.RarityNames[this.rarity]);
        }
        var parts = [];
        parts.push.apply(parts, __spread(prefixes));
        parts.push(names_1.SlotNames[this.slot]);
        parts.push(names_1.ItemNames[this.type]);
        return parts.join(" ");
    };
    Armor.hydrate = function (obj) {
        var armor = Object.assign(new Armor(), obj);
        item_1.default.hydrate(armor, obj);
        return armor;
    };
    return Armor;
}(item_1.default));
exports.default = Armor;
